import type {
  HTMLMultiRangeLivenessUiElement,
  MultiRangeUiConfiguration,
} from '@innovatrics/dot-auto-capture-ui/multi-range-liveness';

import '@innovatrics/dot-auto-capture-ui/multi-range-liveness';
import { useEffect } from 'react';

export const MultiRangeCameraUi = (props: MultiRangeUiConfiguration) => {
  useEffect(() => {
    const uiElement = document.getElementById('x-dot-face-auto-capture-ui') as HTMLMultiRangeLivenessUiElement | null;

    if (uiElement) {
      uiElement.configuration = props;
    }
  });

  return <x-dot-multi-range-liveness-ui id="x-dot-multi-range-liveness-ui" />;
};
